import { useTranslations } from 'next-intl';
import { useClearRefinements } from 'react-instantsearch';

const ClearRefinements: React.FC = () => {
  const { refine: clearRefinements, canRefine } = useClearRefinements();

  const tCatalog = useTranslations('Catalog');

  return (
    <a
      onClick={() => (canRefine ? clearRefinements() : {})}
      data-testid="ClearRefinements-FilterBar-go-to-clear-filters"
    >
      {tCatalog('clearFilters')}
    </a>
  );
};

export default ClearRefinements;
